import { ResourceOptions } from 'react-admin';
import { FaChartPie } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingPools;
export const icon = FaChartPie;
export const options: ResourceOptions = {
  label: 'module.socialTrading.roomPools',
};
